import { t } from "i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Layout } from "../../../common/layout/Layout";
import { useAppDispatch, useAppSelector } from "../../../common/redux/hooks";
import { resetState } from "../../../common/redux/reducers/basicBidReducer";
import { loadBasicBidThunk } from "../../../common/redux/thunks/basic-bid/load-basic-bid-thunk";
import { EventDialog } from "../../sourcing-events/supplier/view-single/EventDialog";
import { NegotiationProvider } from "../../sourcing-events/supplier/view-single/NegotiationContext";
import { EditBasicBidForm } from "./EditBasicBidForm";

export const EditBasicBid = () => {
  const { bidId } = useParams();
  const dispatch = useAppDispatch();
  const bidState = useAppSelector((state) => state.basicBid.bid);

  useEffect(() => {
    if (bidId && bidState?.id !== bidId) {
      dispatch(loadBasicBidThunk({ bidId }));
    }
  }, [bidId, bidState?.id, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  if (bidState) {
    return (
      <Layout>
        <EditBasicBidForm />
        <NegotiationProvider event={bidState.forEvent}>
          <EventDialog event={bidState.forEvent} />
        </NegotiationProvider>
      </Layout>
    );
  }
  return <div>{t("Loading")}...</div>;
};
